import Box from '@mui/material/Box';
import AddUserModal from './AddUsers';
import PropTypes from 'prop-types';
import Add from '@mui/icons-material/Add';
import { AddButton } from '../../../utils/common/styles/commonStyles';

const UserHeader = ({ handleOpenModal, handleCloseModal, isModalOpen }) => {
  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center" mb={1}>
        <AddButton variant="contained" onClick={handleOpenModal} startIcon={<Add />}>
          Add User
        </AddButton>
      </Box>
      <AddUserModal open={isModalOpen} handleClose={handleCloseModal} />
    </>
  );
};

export default UserHeader;

UserHeader.propTypes = {
  handleOpenModal: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
};
